import { render, staticRenderFns } from "./SaidaPaciente.vue?vue&type=template&id=5008a1fb&"
import script from "./SaidaPaciente.vue?vue&type=script&lang=js&"
export * from "./SaidaPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports